import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import React, { useState } from 'react';
import { SubTitle, Checkbox, styled, Chip, CustomLink, Body, Divider } from '@teko/ds-desktop';
import { DownOutlined, DeleteCircleColored } from '@teko/ds-icon';
import { t } from './i18n.es.js';

const FilterCollapse = ({ filter, active = false, activeOptions = [], onClickOption, }) => {
    if (!filter.options.length)
        return null;
    const [show, setShow] = useState(active);
    const [max, setMax] = useState(4);
    const { options } = filter;
    return (jsxs(Collapse, { children: [jsxs(CollapseHeader, Object.assign({ onClick: () => setShow(!show) }, { children: [jsx(SubTitle, Object.assign({ level: 4, weight: "medium" }, { children: filter.name }), void 0), jsx(StyledDownOutlined, { className: show ? 'active' : '', color: "textPrimary" }, void 0)] }), void 0), jsxs(CollapseContent, Object.assign({ className: show ? 'active' : '' }, { children: [options.slice(0, max).map((option, index) => {
                        const isActive = activeOptions.filter((curr) => curr.optionCode === option.optionCode).length > 0;
                        return (jsx(Checkbox, Object.assign({ checked: isActive, onChange: (_checked) => {
                                onClickOption(option);
                            } }, { children: option.optionName }), index));
                    }), max < options.length && (jsx(ViewAll, Object.assign({ onClick: () => setMax(options.length) }, { children: t('Xem thêm') }), void 0))] }), void 0)] }, void 0));
};
const ViewAll = styled.span(({ theme }) => `
  color: ${theme.colors.link500};
  cursor: pointer;
  font-size: 0.75rem;
  margin-left: 1.7rem;
`);
const StyledDownOutlined = styled(DownOutlined) `
  transition: 0.2s;
  &.active {
    transform: rotate(180deg);
  }
`;
const Collapse = styled.div ``;
const CollapseHeader = styled.div `
  display: flex;
  justify-content: space-between;
  height: 1.5rem;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;
const CollapseContent = styled.div(({ theme }) => `
  height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: 0.25rem;
  &.active {
    margin-top: ${theme.spacing.s12};
    height: auto;
  }
`);

const VerticalFilter = ({ filters = [], onClickOption, activeOptions = [], clearFilterLink, }) => {
    if (!filters.length)
        return null;
    return (jsxs(Wrapper, { children: [!!activeOptions.length && (jsxs(Fragment, { children: [jsx(SubTitle, Object.assign({ level: 4, weight: "medium", marginBottom: "s12" }, { children: t('Bộ lọc đã dùng') }), void 0), jsx(ActiveOptionsWrapper, { children: activeOptions.map((option, index) => (jsx(Chip, { content: option.optionName, closable: true, onClick: () => onClickOption(option), onClose: () => onClickOption(option), closeIcon: jsx(DeleteCircleColored, {}, void 0), style: { cursor: 'pointer' } }, index))) }, void 0), jsx(CustomLink, Object.assign({}, clearFilterLink, { children: jsx(Body, Object.assign({ weight: "regular", color: "error500" }, { children: t('Xóa bộ lọc') }), void 0) }), void 0), jsx(Divider, { color: "border", gap: 12 }, void 0)] }, void 0)), filters.map((filter, index) => {
                return (jsxs(React.Fragment, { children: [jsx(FilterCollapse, { onClickOption: onClickOption, active: index < 6, filter: filter, activeOptions: activeOptions }, void 0), index < filters.length - 1 && jsx(Divider, { color: "border", gap: 12 }, void 0)] }, index));
            })] }, void 0));
};
const Wrapper = styled.div(({ theme }) => `
  border-radius: ${theme.borderRadius.m};
  padding: ${theme.spacing.s12};
  background: ${theme.colors.white};
  display: flex;
  flex-direction: column;
`);
const ActiveOptionsWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
`;

export { VerticalFilter as V };
